import EventManager from "../../store/sqftEventManager";
import CabinetShapes from "./cabinetShapes";
import store from "../../../../../../store";
import { setSQFTContextMenuV2 } from "../../../../../../actions/sqftMenuFunctions";
import workspace from "../workspace";
import { renderMeasurementsAroundSnappedShapes } from "../slab/sqftSlabDraw";
import CabinetShapesLayout from "./cabinetShapesLayout";
import { getMousePositionOnField } from "../../../../helpers/sqftHelper";
import { SHAPE_PART_ID } from "../../../../constants";
import { getCurrentLayout } from "../../../../../appLayout";

class CabinetWorkspace {
  constructor() {
    this.eventManager = EventManager;
    this.objectName = { name: 'CabinetWorkspace' };
    this.state = {};
    this.cabinetShapes = new CabinetShapes();
    this.cabinetShapesLayout = new CabinetShapesLayout();
    this.measurementPoints = [];
    this.__crownMoldingParams = {
      distance: 10
    };

    this.initCabinetEvents();
  }

  initCabinetEvents() {
    EventManager.addEvent(EventManager.events.CONTEXTMENU, this.onRightClick, this, EventManager.priorities.OVERLAY);
    EventManager.addEvent(EventManager.events.DROP, this.handleDrop, this, EventManager.priorities.OVERLAY);
    EventManager.addEvent(EventManager.events.DRAG_OVER, this.handleDrag, this, EventManager.priorities.OVERLAY);
    EventManager.addEvent(EventManager.events.RENDER, this.render, this, EventManager.priorities.OVERLAY);
  }

  render(ctx) {
    renderMeasurementsAroundSnappedShapes(ctx);
  }

  deregisterEvents() {
    EventManager.removeEvent(this);
  }

  onRightClick(mousePos, e) {
    store.dispatch(setSQFTContextMenuV2({
      isOpened: true,
      title: workspace.intl.formatMessage({ id: "sqft.contextmenu.properties.title" }),
      menuItems: [
        {
          title: 'Change Cabinet Style',
          callback: new Function()
        },
        {
          title: 'Generate Countertop',
          callback: new Function()
        },
        {
          title: 'Generate Backsplash',
          callback: new Function()
        },
      ],
      position: { left: mousePos.x, top: mousePos.y }
    }));
    document.addEventListener('click', this.closeContextMenu);
    void e;
  }

  closeContextMenu(e) {
    const navClick = e.target.closest('[class*="contextmenu2"]');
    if (!navClick && !window.touchMove) {
      store.dispatch(setSQFTContextMenuV2({
        isOpened: false,
        title: '',
        menuItems: [],
        position: {}
      }));
    }
  }

  handleDrop(mousePos, e) {
    e.preventDefault();
    const featureId = JSON.parse(e.dataTransfer.getData('featureId'));
    const parentFeatureId = JSON.parse(e.dataTransfer.getData('parentFeatureId'));
    const partId = JSON.parse(e.dataTransfer.getData('partId'));

    if ([SHAPE_PART_ID.upper_cabinet_boxes, SHAPE_PART_ID.lower_cabinet_boxes, SHAPE_PART_ID.tall_cabinet_boxes,
      SHAPE_PART_ID.top_cabinet, SHAPE_PART_ID.bottom_cabinet, SHAPE_PART_ID.tall_cabinet
    ].includes(partId)) {

      const layout = getCurrentLayout();
      const feature = layout.getFeatureById(featureId, true);
      const parentFeature = layout.getFeatureById(parentFeatureId, true);
      let shapeId = null;
      const mousePosOnField = getMousePositionOnField(mousePos.x, mousePos.y);
      shapeId = this.cabinetShapes.addShape(feature, parentFeature, mousePosOnField);

      const shape = workspace.getShapeById(shapeId);
      shape.shapeAutoShuffle.handlePlaceShapeOnTheLine();
    }
  }

  handleDrag(mousePos, e) {
    e.preventDefault();
    // update hovered lines for rendering auto shuffle possibilities
    const hoveredLines = workspace.getHoveredLines();
    void hoveredLines;
  }
}

export default new CabinetWorkspace();
